
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"20.024","width":"20.047"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.482 10.026l8.24-8.194a.992.992 0 000-1.414 1.016 1.016 0 00-1.429 0l-8.232 8.187L1.753.296a1.009 1.009 0 00-1.428 0 1.015 1.015 0 000 1.432l8.302 8.303-8.332 8.286a.994.994 0 000 1.414 1.016 1.016 0 001.428 0l8.325-8.279 8.275 8.276a1.009 1.009 0 001.428 0 1.015 1.015 0 000-1.432z","fill":"#53504c"}})])
          )
        }
      }
    